import {
  type GetEventDetailsQuery,
  GetGamedayByEventIdQuery,
  GetUserEventRegistrationQuery,
} from 'types/generated/client';
import { type EventPageFieldsFragment } from 'types/generated/server';
import { useGetCurrentUser } from 'hooks/useGetCurrentUser';

export const PLAY_SESSIONS_ID = 'play-sessions';

export enum Steps {
  CreateAccount = 'CREATE_ACCOUNT',
  Login = 'LOGIN',
  AddEvent = 'ADD_EVENT',
  PartnerSetup = 'PARTNER_SETUP',
  TournamentRequirements = 'TOURNAMENT_REQUIREMENTS',
  PaymentForm = 'PAYMENT_FORM',
  AdditionalDetails = 'ADDITIONAL_DETAILS',
  Closed = 'CLOSED',
  LoadingSkeleton = 'LOADING_SKELETON',
  Withdraw = 'WITHDRAW',
}

interface Faq {
  question: string;
  answer: string;
}

export interface PageProps {
  event: EventPageFieldsFragment;
  faqs: Faq[];
  jsonLd: string;
}

export type Event = Omit<
  Exclude<GetEventDetailsQuery['eventsByPk'], null | undefined>,
  '__typename'
>;

export interface Props {
  event: Event;
  faqs: Faq[];
  jsonLd?: string;
  isReview?: boolean;
  eventGroups?: Event['groups'];
  isPreview?: boolean;
  isUserOrganizer: boolean;
  isEdit?: boolean;
}

export type EventProps = { event: Event; isUserOrganizer?: boolean; onGameDayClick?: () => void; onEventDataChanged?: () => void };

export type EventPropsForForm = EventProps & {
  eventGroups?: Event['groups'];
  isReview?: boolean;
};

export interface RegisterProps {
  setSteps: React.Dispatch<React.SetStateAction<Steps>>;
  event: Event;
  registrations?: GetUserEventRegistrationQuery;
  user: ReturnType<typeof useGetCurrentUser>['user'];
  /** Optional selectedGroups when coming from AddEvents/UserEventList so we can run VAIR gender mismatch alert */
  handleNext: (selectedGroups?: { groupId: string; partnerEmail?: string; partnerName?: string }[]) => void;
}

export const EXIT_TEXT = 'No thanks, take me to the tournament';

export const ENABLE_BIRTHDAY_REQUIREMENT = false;

// Type definitions for VAIR round status
export type VairRound = NonNullable<
  NonNullable<
    NonNullable<NonNullable<GetGamedayByEventIdQuery['eventsByPk']>['groups']>[0]['sequences']
  >[0]['pools']
>[0]['rounds'][0];

export type RemainingRound = {
  roundOrder: number;
  title: string | null;
  incompleteMatches: number;
};

export type RoundStatusData = {
  remainingRounds: RemainingRound[];
  completedRounds: VairRound[];
  totalMatches: number;
  totalRounds: number;
  totalIncompleteMatches: number;
};

export type RoundStatusResult = {
  isComplete: boolean;
  remainingRounds: RemainingRound[];
  completedRounds: VairRound[];
  totalMatches: number;
  totalRounds: number;
  totalIncompleteMatches: number;
};
